import React, { useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom"; //se importa  y se extrae por destructuring
import { Layout } from "antd";
import "./LayoutAdmin.scss"; //se importaran prox. los estilos
import MenuTop from "../components/Admin/MenuTop"; //importacion menuTop
import MenuSider from "../components/Admin/MenuSider";
import AdminSingIn from "../pages/Admin/SignIn/SingIn"; //importacion de la pagina SingIN
import useAuth from "../hooks/useAuth";

export default function LayoutAdmin(props) {
  const { routes } = props; //se extrae las routas que reciben los props
  const { Header, Content, Footer } = Layout; //se extraen de la paqueteria layout.
  const [menuCollapsed, setMenuCollapsed] = useState(true); //false quiere decir que esta abierto el menu
  const { user, isLoading } = useAuth();

  if (!user && !isLoading) {
    //si el usuario no esta logueado
    return (
      <>
        <Route path="/admin/login" component={AdminSingIn} />;
        <Redirect to="/admin/login" />
      </>
    );
  }
  if (user && !isLoading) {
    //si el usuario está logueado
    return (
      <div>
        <Layout>
          <MenuSider menuCollapsed={menuCollapsed} />
          <Layout
            className="layout-admin"
            style={{ marginLeft: menuCollapsed ? "80px" : "200px" }}
          >
            <Header className="layout-admin_header">
              <MenuTop
                menuCollapsed={menuCollapsed}
                setMenuCollapsed={setMenuCollapsed}
              />
            </Header>
            <Content className="layout-admin_content">
              <LoadRoutes routes={routes} />
            </Content>
            <Footer className="layout-admin_footer">Israel Garcia Lopez</Footer>
          </Layout>
        </Layout>
      </div>
    );
  }
  return null;
}
//fucion que cargará adecuadamente la ruta de /admin....../admin/login
function LoadRoutes({ routes }) {
  //componente porque inicia el "Mayuscula"
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
    </Switch>
  );
}
